<template>
  <div class="panel-container"
    :style="{
      '--sidebar-width': sidebarWidth,
    }"
  >
    <!-- 左侧收缩栏 -->
    <div class="panel-sidebar">
      <div class="panel-toggle" @click="togglePanel">
        <SvgIcon iconName="left"
          :style="{
            transform: isCollapsed?'rotateZ(180deg)':''
          }"
        />
      </div>
      
      <!-- 收缩状态下的快速切换按钮 -->
      <div class="quick-access-buttons" >
        <div 
          class="quick-access-button" 
          v-for="(tab, tabIndex) of activeList"
          :key="tabIndex"
          :class="{ 'active': activeItem['name'] == tab['name'] }"
          @click="switchTab(tab)"
          :title="tab.name"
        >
          <SvgIcon :iconName="tab['icon']" />
        </div>
        
      </div>
    </div>
    
    <!-- 主内容区域 -->
    <div class="panel-main" v-show="!isCollapsed">
      <!-- 顶部标题栏 -->
      <div class="panel-header-container">
        <div class="panel-header">
          <span class="panel-title">{{ activeItem['name'] }}</span>
          <div>
            <button
              v-for="(btn, index) of (activeItem['controlBtns'] || []).filter((btn)=> btn )"
              :key="index"
              @click="btn.onClick"
              :title="btn.name"
              class="download-btn"
            >
              <component
                :is="btn['svg']"
              ></component>
            </button>
          </div>
        </div>

      <!-- 导出格式选择对话框 -->
       <!-- 地图导出 -->
      <el-dialog
        v-model="showMapDialog"
        title="选择导出格式"
        width="25rem"
      >
        <div class="option-group">
          <h4>侦察地图名称</h4>
          <el-input 
            v-model="currentMapName" 
            placeholder="自动填充当前地图名称"
            readonly
            style="width: 100%"
          />
        </div>
        <div >
          <el-radio-group v-model="selectedNodeType">
            <el-radio value="URL">URL</el-radio>
            <el-radio value="geojson">geojson</el-radio>
            <!-- <el-radio value="shapefile">shapefile</el-radio> -->
          </el-radio-group>
        </div>
        <template #footer>
          <span>
            <el-button @click="showMapDialog = false">取消</el-button>
            <el-button type="primary" @click="handleDownloadMap">
              确认导出
            </el-button>
          </span>
        </template>
      </el-dialog>
      <!-- 收藏导出 -->
      <el-dialog
        v-model="showFavoriteDialog"
        title="选择导出格式"
        width="25rem"
      >
        <div class="option-group">
          <h4>我的收藏名称</h4>
          <el-input 
            v-model="currentFavoriteName" 
            placeholder="自动填充当前收藏名称"
            readonly
            style="width: 100%"
          />
        </div>
        <div >
          <el-radio-group v-model="selectedMapType">
            <el-radio value="geojson">geojson</el-radio>
            <el-radio value="shapefile">shapefile</el-radio>
          </el-radio-group>
        </div>
        <template #footer>
          <span>
            <el-button @click="showFavoriteDialog = false">取消</el-button>
            <el-button type="primary" @click="handleDownloadFavorite">
              确认导出
            </el-button>
          </span>
        </template>
      </el-dialog>
      </div>
      
      <!-- 内容区域 -->
      <div class="panel-menu">
        <component
          :is="activeItem['domCom']"
        ></component>
      </div>
      
      <teleport to="#home-body">
        <FeatureInfo></FeatureInfo>
      </teleport>
    </div>

  </div>
</template>

<script setup>
// 脚本部分保持不变
import { ref, computed, defineComponent, markRaw, defineAsyncComponent,
  h,
} from 'vue';
import store from '@/store';
import SvgIcon from '@/components/SvgIcon';
import SelectedTreeTable from './components/SelectedTreeTable';
import MyMapsTable from './components/MyMapsTable';
import { message } from '@/utils/js/initVariable'
import { exportFootPrintMap, exportFavorite, importOffline } from '@/api/ExportData'

import WorkSpace from './components/WorkSpace';
import CustomPolygon from './components/CustomPolygon';
import FeatureInfo from './components/FeatureInfo';
import Location from './components/Location';
import VideoRecord from './components/VideoRecord';
import ExposureRecord from './components/ExposureRecord';

const props = defineProps({
  defaultCollapsed: {
    type: Boolean,
    default: false
  },
  showDateFilter: {
    type: Boolean,
    default: true
  },
});

const emit = defineEmits([]);

const isOffline = ref(__IS__OFFLINE__);

// 快照


const showMapDialog = ref(false);
const showFavoriteDialog = ref(false);
const selectedNodeType = ref('')
const selectedMapType = ref('');
const homeMap = computed(() => store.getters.getHomeMap);
const map = homeMap.value;
const isCollapsed = computed(()=> store.getters['isCollapsed']),
      sidebarWidth = ref('3rem');

const SelectedTreeTableRef = ref(), exportLayerFn = ()=>{
  SelectedTreeTableRef.value && SelectedTreeTableRef.value.exportLayerFn && SelectedTreeTableRef.value.exportLayerFn();
}
const customPolygonRef = ref(), addCustomPolygonFn = ()=>{
  customPolygonRef.value && customPolygonRef.value.addCustomPolygonFn && customPolygonRef.value.addCustomPolygonFn();
},
exportCustomPolygonFn = ()=>{
  customPolygonRef.value && customPolygonRef.value.exportCustomPolygonFn && customPolygonRef.value.exportCustomPolygonFn();
}

const importLoad = ref(false);
const importFileFn = ()=>{
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = '.zip';
  input.click();
  input.onchange = (event)=>{
    const file = event.target.files[0];
    if (!file) return;
    importLoad.value = true;
    importOffline({ file }).then(res=>{
      if(res.data.code == 1004){
        message(res.data.msg);
      }
      importLoad.value = false;
    }).catch(err=>{
      importLoad.value = false;
      message('文件异常');
      console.log(err);
    });

  }
}

const workSpaceRef = ref(), addWorkSpace = ()=>{
  workSpaceRef.value && workSpaceRef.value.addWorkSpaceFn && workSpaceRef.value.addWorkSpaceFn();
}

const exposureRecordRef = ref(), downloadExposureFn = ()=>{
  exposureRecordRef.value && exposureRecordRef.value.downloadExposureFn && exposureRecordRef.value.downloadExposureFn();
}

const activeList = computed(()=>{
        return [
          { name: '侦察地图目录', icon: 'map-2', 
            domCom: markRaw(
              defineComponent({
                setup(){
                  return ()=>{
                    return h(SelectedTreeTable, {
                      ref: SelectedTreeTableRef,
                    });
                  }
                }
              })
            ),
            controlBtns: [
              { name: '导出底图', onClick: exportLayerFn,
                svg: markRaw(
                  defineComponent({
                    setup(){
                      return ()=>{
                        return h(SvgIcon, {
                          iconName: 'download',
                        });
                      }
                    }
                  })
                ),
              },
              isOffline.value? {
                name: '导入数据', onClick: importFileFn, 
                svg: markRaw(
                  defineComponent({
                    setup(){
                      return ()=>{
                        return h(SvgIcon, {
                          iconName: importLoad.value?'load-icon':'file-import',
                        });
                      }
                    }
                  })
                ),
              }:undefined,
            ]
          },
          // { name: '位置', icon: 'polygon-icon',
          //   domCom: markRaw(
          //     defineComponent({
          //       setup(){
          //         return ()=>{
          //           return h(Location);
          //         }
          //       }
          //     })
          //   ),
          // },
          // { name: '影像', icon: 'image',
          //   domCom: markRaw(
          //     defineComponent({
          //       setup(){
          //         return ()=>{
          //           return h(RegionalShootRecord);
          //         }
          //       }
          //     })
          //   ),
          // },
          // { name: '视频', icon: 'film',
          //   domCom: markRaw(
          //     defineComponent({
          //       setup(){
          //         return ()=>{
          //           return h(VideoRecord);
          //         }
          //       }
          //     })
          //   ),
          // },
          // { name: '线索数据', icon: 'chart',
          //   domCom: markRaw(
          //     defineComponent({
          //       setup(){
          //         return ()=>{
          //           return h(ExposureRecord, {
          //             ref: exposureRecordRef,
          //           });
          //         }
          //       }
          //     })
          //   ),
          //   controlBtns: [
          //     { name: '导出线索区数据', onClick: downloadExposureFn,
          //       svg: markRaw(
          //         defineComponent({
          //           setup(){
          //             return ()=>{
          //               return h(SvgIcon, {
          //                 iconName: 'download',
          //               });
          //             }
          //           }
          //         })
          //       ),
          //     }
          //   ],
          // },
          // (store.getters['isSuperAdmin'] && !__IS__OFFLINE__)?{ className: 'workSpace', name: '快照', icon: 'work-space',
          //   domCom: markRaw(
          //     defineComponent({
          //       setup(){
          //         return ()=>{
          //           return h(WorkSpace, {
          //             ref: workSpaceRef,
          //           });
          //         }
          //       }
          //     })
          //   ),
          //   controlBtns: [
          //     { name: '新增快照', onClick: addWorkSpace,
          //       svg: markRaw(
          //         defineComponent({
          //           setup(){
          //             return ()=>{
          //               return h(SvgIcon, {
          //                 iconName: 'plus-border',
          //               });
          //             }
          //           }
          //         })
          //       ),
          //     }
          //   ]
          // }:undefined,
        ].filter(e=> e);
      }),
      activeItem = ref(activeList.value.at(0));


const currentMapName = ref('');
const currentFavoriteName = ref('');

const openMapDialog = () => {
  const selectedNode = store.getters.getSelectedNode;
  console.log("selectedNode", selectedNode);
  if (!selectedNode) {
    message('请先选择一个图层', 0);
    return;
  }
  
  selectedNodeType.value = ''; 
  currentMapName.value = selectedNode.name;
  showMapDialog.value = true;
};

const openFavoriteDialog = () => {
  const selectedMap = store.getters.getSelectedMap;
  if (!selectedMap) {
    message('请先选择一个收藏', 0);
    return;
  }
  
  selectedMapType.value = '';
  currentFavoriteName.value = selectedMap.name;
  showFavoriteDialog.value = true;
};
// 我的收藏导出
const handleDownloadFavorite = async () => {
  try {
    const selectedMap = store.getters.getSelectedMap;
    if (!selectedMap) {
      message('请先选择一个收藏', 0);
      return;
    }

    if (!selectedMapType.value) {
      message('请选择导出格式', 0);
      return;
    }

    const mapType = {
      'URL': 4,
      'geojson': 1,
      'shapefile': 3
    };

    const params = {
      id: selectedMap.id,
      exportName: currentFavoriteName.value,
      type: mapType[selectedMapType.value]
    };

    exportFavorite(params).then(res => {
      if (res.data.code === 1004) {
        message('导出收藏任务创建成功,请前往下载中心查看', 1);
      }
    });

  } catch (error) {
    console.error('导出收藏时出错:', error);
    message('导出过程中发生错误', 0);
  } finally {
    showFavoriteDialog.value = false;
  }
};

const createFavorite = () => {
  emit('download');
};
// 侦察地图导出
const handleDownloadMap = async () => {
  try {
    if (!selectedNodeType.value) {
      message('请选择导出格式', 0);
      return;
    }

    const selectedNode = store.getters.getSelectedNode;
    if (!selectedNode) {
      message('请先选择一个图层', 0);
      return;
    }

    const nodeType = {
      'URL': 4,
      'geojson': 1,
      'shapefile': 3
    };

    const params = {
      id: selectedNode.id,
      exportName: currentMapName.value,
      type: nodeType[selectedNodeType.value]
    };

    exportFootPrintMap(params).then(res => {
      if (res.data.code === 1004) {
        message('导出底图任务创建成功,请前往下载中心查看', 1);
      }
    });

  } catch (error) {
    console.error('导出地图时出错:', error);
    message('导出过程中发生错误', 0);
  } finally {
    showMapDialog.value = false;
  }
};
const togglePanel = () => {
  store.commit('isCollapsedChange', !isCollapsed.value);
};

const switchTab = (tab) => {
  activeItem.value = tab;
};


</script>

<style lang="less">
@import url('./css/ManagePanel.less');
</style>

<style lang="less" scoped>
/* 尺寸变量 */
.panel-container {
  --nav-collapsed-duration: 0.4s;
  --border-color: #e0e0e0;
  --icon-color: #5f6368;
  --hover-bg: #f1f3f4;
  --active-bg: #e8f0fe;
}

/* 容器样式 */
.panel-container {
  position: absolute;
  left: 10px;
  top: 10px;
  height: calc(100% - 20px);
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
  border: 1px solid var(--border-color);
  transition: width var(--nav-collapsed-duration) ease;
  z-index: 10;
  overflow: hidden;
  display: flex;
}

/* 收缩状态 */
// .panel-container.panel-collapsed {
//   width: var(--sidebar-width);
// }

// /* 未收缩状态 */
// .panel-container:not(.panel-collapsed) {
//   width: var(--panel-width);
// }
.panel-container{
  width: var(--nav-panel-width);
}

/* 左侧边栏 */
.panel-sidebar {
  width: var(--sidebar-width);
  display: flex;
  flex-direction: column;
  background-color: #f8f9fa;
  border-right: 1px solid var(--border-color);
}

/* 主内容区域 */
.panel-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

/* 切换按钮 */
.panel-toggle {
  width: 32px;
  height: 32px;
  margin: 8px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  transition: all var(--nav-collapsed-duration) ease;
}
.panel-toggle:hover {
  background-color: var(--hover-bg);
}
.panel-toggle .svg-icon {
  width: 18px;
  height: 18px;
  /* color: var(--icon-color); */
}

/* 顶部栏容器 */
.panel-header-container {
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-color);
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.panel-title {
  font-size: 15px;
  font-weight: 500;
  color: #202124;
}

.download-btn {
  width: 32px;
  height: 32px;
  /* display: flex; */
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all var(--nav-collapsed-duration) ease;
}
.download-btn:hover {
  background-color: var(--hover-bg);
}
.download-btn .svg-icon {
  width: 18px;
  height: 18px;
  color: var(--icon-color);
}

/* 菜单容器 */
.panel-menu {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 树形表格样式 */
.tree-table {
  flex: 1;
  /* padding: 8px 0; */
  min-height: 0;
  /* overflow: auto; */
}

/* 快速访问按钮样式 */
.quick-access-buttons {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 0;
}

.quick-access-button {
  width: 32px;
  height: 32px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  transition: all var(--nav-collapsed-duration) ease;
}

.quick-access-button:hover {
  background-color: var(--hover-bg);
}

.quick-access-button.active {
  background-color: var(--active-bg);
}

.quick-access-button .svg-icon {
  width: 18px;
  height: 18px;
  /* color: var(--icon-color); */
}
</style>